import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/home/home_doctor_image_001.png'
import _imports_1 from '@/assets/images/home/home_doctor_image_002.png'
import _imports_2 from '@/assets/images/home/home_doctor_image_003_new.png'
import _imports_3 from '@/assets/images/home/home_doctor_image_004.png'
import _imports_4 from '@/assets/images/layout/APP_LOGO.svg'
import _imports_5 from '@/assets/images/home/download_scan_qrcode_img.png'


const _hoisted_1 = { class: "charm-message-cont section-message-cont" }
const _hoisted_2 = { class: "btn-cont" }
const _hoisted_3 = { class: "other-cosmetic-procedures section-message-cont" }
const _hoisted_4 = { class: "cosmetic-procedures-cont" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "btn-cont" }
const _hoisted_8 = { class: "download-message-cont section-message-cont" }
const _hoisted_9 = { class: "logo-box" }

import { NButton, NCarousel, NIcon } from "naive-ui";
import { computed, nextTick, onMounted, onUnmounted, ref } from "vue";
import { ProcedureTransMockList } from "@/mock/MockList";
import VideoPreviewModal from "@/components/VideoPreviewModal.vue";
import { useRouter } from "vue-router";
import videoUrl from "@/assets/images/home/App-Demo-V10.mp4";
import videoH5Url from "@/assets/images/home/App-Demo-H5.mp4";
import { BannersList } from "@/constant";
import { getRandomElements } from "@/utils/util";


export default /*@__PURE__*/_defineComponent({
  __name: 'homeIndex',
  setup(__props) {

const router = useRouter();
const otherCosmeticProceduresList = ref<any>(ProcedureTransMockList);
const screenMinWidth = ref<number>(1440);
const calcDoctorImgContWidth = ref<number>(480);
const showVideoPreviewModal = ref<boolean>(false);
const videoPreviewOpts = {
    showEdit: false,
    src: videoUrl,
};
const videoH5PreviewOpts = {
    showEdit: false,
    src: videoH5Url,
};
const curVideoPreivewOpts = ref(videoPreviewOpts);

const calcDoctorImgContHeightObj = computed(() => {
    return {
        height: (calcDoctorImgContWidth.value * 600) / 480 + "px",
    };
});
const curBannerList = computed(() => {
    const list = getRandomElements(BannersList, 3);
    return list;
});

const isTitleBarFixed = ref<boolean>(true);

// 计算屏幕大小
const calcScreenMinWidth = (vWidth: number) => {
    if (vWidth >= 1440) {
        screenMinWidth.value = 1440;
    }
    if (1020 <= vWidth && vWidth < 1440) {
        screenMinWidth.value = 1020;
    }
    if (vWidth < 1020) {
        screenMinWidth.value = 744;
    }
};

const _onShowVideoPreviewModal = () => {
    showVideoPreviewModal.value = !showVideoPreviewModal.value;
};

const _handleShowCharmVideo = () => {
    curVideoPreivewOpts.value = videoPreviewOpts;
    nextTick(() => {
        _onShowVideoPreviewModal();
    });
};

const _handleShowCharmH5Video = () => {
    curVideoPreivewOpts.value = videoH5PreviewOpts;
    nextTick(() => {
        _onShowVideoPreviewModal();
    });
};

const _goToDoctorsHomePage = () => {
    router.push({
        path: "/doctor",
    });
};

const _goToPostHomePage = () => {
    router.push({
        path: "/post",
    });
};

const _goToProcedureDetailPage = (categoryName: string) => {
    router.push({
        path: "/procedure/procedureDetail",
        query: {
            categoryName,
        },
    });
};

const _goToProcedureHomePage = () => {
    router.push({
        path: "/procedure",
    });
};

onMounted(() => {
    calcScreenMinWidth(window.innerWidth);
    calcDoctorImgContWidth.value = (window.innerWidth - 2 * 80) / 3;
    window.addEventListener("resize", () => {
        calcScreenMinWidth(window.innerWidth);
        calcDoctorImgContWidth.value = (window.innerWidth - 2 * 80) / 3;
    });
});

onUnmounted(() => {
    window.removeEventListener("resize", () => {
        calcScreenMinWidth(window.innerWidth);
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["home-index", { 'top-bar-dis': isTitleBarFixed.value }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(NCarousel), {
        autoplay: "",
        interval: 3000,
        "show-dots": true
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(curBannerList.value, (item, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "img-cont"
            }, [
              _createElementVNode("div", {
                class: "musk-banner-bg",
                style: _normalizeStyle(`background: linear-gradient(90deg, #000 0%, #000 12%, rgba(0, 0, 0, 0.00) 80%), url(${item.imgSrc}) lightgray center 20% / cover no-repeat ;`)
              }, null, 4)
            ]))
          }), 128))
        ]),
        _: 1
      }),
      _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"slogon-cont\" data-v-782eec7b><div class=\"slogon-title\" data-v-782eec7b>Live Fully-Not Just Exist</div><div class=\"slogon-text\" data-v-782eec7b> We proudly donate 100% of profits from doctor bookings and subscriptions to charity—turning your pursuit of Charm-Vibe into real-world impact. </div></div><div class=\"loading-bar-cont\" data-v-782eec7b><div class=\"loading-bar\" data-v-782eec7b></div></div><div class=\"message-cont\" data-v-782eec7b><div class=\"message-title text-gradient\" data-v-782eec7b> Guided by Expertise. Driven by Purpose. Focused on You </div></div>", 3)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(NButton), {
          class: "gradient-btn",
          color: "#000000",
          onClick: _handleShowCharmVideo
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode(" What is Charm? ")
          ])),
          _: 1
        }),
        _createVNode(_unref(NButton), {
          class: "default-btn",
          color: "#ffffff",
          "text-color": "#000000",
          onClick: _goToDoctorsHomePage
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode(" Consult a doctor ")
          ])),
          _: 1
        })
      ])
    ]),
    _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"doctor-message-cont section-message-cont\" data-v-782eec7b><div class=\"img-cont\" data-v-782eec7b><div class=\"img-item\" data-v-782eec7b><div class=\"img-item-bg\" data-v-782eec7b><img src=\"" + _imports_0 + "\" data-v-782eec7b></div><div class=\"img-item-message\" data-v-782eec7b><span data-v-782eec7b>Embrace flawless skin</span></div></div><div class=\"img-item\" data-v-782eec7b><div class=\"img-item-bg\" data-v-782eec7b><img src=\"" + _imports_1 + "\" data-v-782eec7b></div><div class=\"img-item-message\" data-v-782eec7b><span data-v-782eec7b>Luminous complexion</span></div></div><div class=\"img-item\" data-v-782eec7b><div class=\"img-item-bg\" data-v-782eec7b><img src=\"" + _imports_2 + "\" data-v-782eec7b></div><div class=\"img-item-message\" data-v-782eec7b><span data-v-782eec7b>Visibly reduced signs of ageing</span></div></div></div><div class=\"message-cont\" data-v-782eec7b><div class=\"message-title text-gradient\" data-v-782eec7b> Exclusivity. Expertise. Elegance </div><div class=\"message-describe\" data-v-782eec7b> Where luxury meets trust—Charm-Vibe is your gateway to verified experts,and your lifestyle of beauty and confidence begins. </div></div></div><div class=\"post-message-cont section-message-cont\" data-v-782eec7b><div class=\"img-cont\" data-v-782eec7b><div class=\"img-cont-bg\" data-v-782eec7b><img src=\"" + _imports_3 + "\" data-v-782eec7b></div></div><div class=\"message-cont\" data-v-782eec7b><div class=\"message-title text-gradient\" data-v-782eec7b> Charm-Vibe charity: Restoring Smiles, Rebuilding Futures </div><div class=\"message-describe\" data-v-782eec7b> Luxury With Heart. Medicine With Meaning. <br data-v-782eec7b>Funding their smiles. </div></div></div>", 2)),
    _createElementVNode("div", _hoisted_3, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "message-cont" }, [
        _createElementVNode("div", { class: "message-title text-gradient" }, " Other Cosmetic Procedures ")
      ], -1)),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherCosmeticProceduresList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "cosmetic-procedures-item",
            onClick: ($event: any) => (_goToProcedureDetailPage(item.categoryName))
          }, [
            _createElementVNode("img", {
              src: item.imgSrc
            }, null, 8, _hoisted_6),
            _createElementVNode("div", null, _toDisplayString(item.name), 1)
          ], 8, _hoisted_5))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(NButton), {
          class: "gradient-btn",
          color: "#000000",
          onClick: _goToProcedureHomePage
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode(" View All Procedures ")
          ])),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", {
        class: "phone-cont",
        onClick: _handleShowCharmH5Video
      }, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_unref(NIcon), {
            class: "btn-icon",
            size: "120"
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createElementVNode("img", { src: _imports_4 }, null, -1)
            ])),
            _: 1
          }),
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text" }, "Charm", -1))
        ])
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "qrcode-cont" }, [
        _createElementVNode("img", { src: _imports_5 }),
        _createElementVNode("div", { class: "tip" }, "Scan to view the mobile")
      ], -1))
    ]),
    (showVideoPreviewModal.value)
      ? (_openBlock(), _createBlock(VideoPreviewModal, {
          key: 0,
          show: showVideoPreviewModal.value,
          "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((showVideoPreviewModal).value = $event)),
          options: curVideoPreivewOpts.value,
          to: ".home-index"
        }, null, 8, ["show", "options"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})